export const initialFormData = {
  firstName: '',
  middleName: '',
  lastName: '',
  email: '',
  password: '',
  role: 'student',
  courseId: '',
  mobile: '',
  whatsapp: '',
  linkedIn: '',
  department: '',
  resumeUrl: '',
  country: '', // Will be set to actual country ID
  state: '',
  cityId: '',
  heardFrom: '',
  motivation: '',
  gender: '',
  currentCity: '',
  diplomaDone: '',
  stream: '',
  semester: '',
  tenthMarks: '',
  tenthMarksType: 'Percentage', // 'Percentage' or 'CGPA'
  twelfthMarks: '',
  twelfthMarksType: 'Percentage', // 'Percentage' or 'CGPA'
  btechMarks: '',
  btechMarksType: 'Percentage', // 'Percentage' or 'CGPA'
  tenthYear: '',
  twelfthYear: '',
  btechYear: '',
  // M.Tech fields
  mtechYear: '',
  mtechMarks: '',
  mtechMarksType: 'Percentage', // 'Percentage' or 'CGPA'
  mtechInstitute: '',
  mtechSpecialization: '',
  // PhD fields
  phdDone: 'No', // 'Yes' or 'No' - default to 'No'
  phdYear: '',
  educationGap: '',
  hasGapInEducation: '',
  gapInEducationJustification: '',
  hasGapAfterHighestEducation: '',
  gapAfterHighestEducationJustification: '',
  profilePreference: '',
  modeOfCourse: '',
  // FLATTENED EDUCATION FIELDS
  degree: '',
  university: '',
  yearOfPassing: '',
  percentage: '',
  percentageType: 'Percentage', // 'Percentage' or 'CGPA'
  btechInstitute: '',
  btechSpecialization: '',
  // ADDITIONAL PERSONAL INFORMATION
  dob: '',
  address: '',
  permanentAddress: '',
  joiningKitAddress: '', // 'current' or 'permanent'
  joiningKitReceived: '', // 'Yes' or 'No'
  pincode: '',
  // GUARDIAN INFORMATION
  guardianName: '',
  guardianContact: '',
  guardianEmail: '',
  parentsName: '',
  parentsPhone: '',
  parentsEmail: '',
  // PROFESSIONAL INFORMATION
  employeeId: '',
  experienceYears: '',
  availability: '',
  // ADDITIONAL INFORMATION
  bio: '',
  notes: '',
  training: [],
  performance: [],
  projects: [],
  placement: {
    companyName: '',
    position: '',
    package: '',
    location: '',
    interviewDate: '',
    result: '',
    offerDetails: '',
    placementDate: '', // Date of placement
    joiningDate: '',
    shouldMoveToAlumni: 'Yes', // Default to Yes
    placementGroupRemovalReason: '',
    removedFromPlacementGroup: false
  },
  placementStatus: '', // 'Placed', 'In progress', 'Hold', 'Not interested'
  holdTillDate: '',
  // NEW FIELDS FOR UPDATED REQUIREMENTS
  veStudentId: '', // VE Student ID
  studentIdIntakeMode: 'generate',
  programType: '',
  locationOfCenter: '', // From batch / VE "Location of Center"
  courseCategoryId: '', // Course Category
  batchId: '', // Batch Name (selected from batches)
  domainId: '', // Selected Domain
  batchStartDate: '', // Batch Start Date
  courseCompletionDate: '', // Course completion Date
  attendancePercentage: '', // Attendance percentage
  studentStatus: 'Ongoing', // 'Completed', 'Ongoing', 'On Hold', 'Left in between'
  followUpNeeded: false, // Follow-Up Needed (Y/N)
  insuranceTaken: false, // Insurance Taken (Yes/No)
  insuranceDeactivated: false, // Insurance Deactivated (Yes/No)
  certificationIssued: 'No', // Certificate Issued (Yes/No) - Show only when course completed
  videoTestimonyReceived: 'No', // Video/Testimony Received (Yes/No) - Show when course done/placed/left
  testimonyReceived: 'No', // Testimony Received (Yes/No) - Show when course done/placed/left
  // Counselling Sessions (4 sessions)
  counsellingSessions: [
    { sessionDate: '', counselorId: '', remarks: '' },
    { sessionDate: '', counselorId: '', remarks: '' },
    { sessionDate: '', counselorId: '', remarks: '' },
    { sessionDate: '', counselorId: '', remarks: '' }
  ],
  interviewReadiness: {
    enrollmentId: '',
    interviewReady: '',
    allModulesComplete: '',
    projectSubmitted: '',
    studentReadiness: '',
    trainerReadiness: '',
    resumeReadySubmitted: '',
    mockInterviewDone: '',
    numberOfMockInterviews: '',
    communicationSkillsRating: '',
    attitudeRating: '',
    presentationRating: '',
    technicalReadinessRating: '',
    areasToImprove: '',
    feedbackScore: '',
    inPlacementGroup: '',
    inMockGroup: '',
    inUnderpreparedGroup: '',
  },
  appliedForTruechip: '',
  truechipResult: '',
  testimony: {
    enrollmentId: '',
    videoTestimonyReceived: '',
    textTestimonyReceived: '',
    textTestimonyContent: '',
    wantToContributeAsTrainer: '',
    feedbackToImproveTraining: '',
  },
  additionalEnrollments: [],
};

export const formReducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_FIELD':
      return { ...state, [action.field]: action.value };
    case 'UPDATE_FIELDS':
      return { ...state, ...(action.fields || {}) };
    case 'UPDATE_NESTED_FIELD':
      return {
        ...state,
        [action.section]: {
          ...state[action.section],
          [action.field]: action.value
        }
      };
    case 'UPDATE_COUNSELLING_SESSION':
      const updatedSessions = [...state.counsellingSessions];
      updatedSessions[action.index] = {
        ...updatedSessions[action.index],
        [action.field]: action.value
      };
      return { ...state, counsellingSessions: updatedSessions };
    case 'LOAD_DATA': {
      const counsellingSessionsToSet = Array.isArray(action.data?.counsellingSessions)
        ? [...action.data.counsellingSessions]
        : action.data?.counsellingSessions || initialFormData.counsellingSessions;
      let placementToSet = initialFormData.placement;
      if (action.data?.placement) {
        placementToSet =
          typeof action.data.placement === 'object' && !Array.isArray(action.data.placement)
            ? { ...initialFormData.placement, ...action.data.placement }
            : action.data.placement;
      }
      return {
        ...state,
        ...action.data,
        counsellingSessions: counsellingSessionsToSet,
        placement: placementToSet,
        interviewReadiness: {
          ...initialFormData.interviewReadiness,
          ...(action.data?.interviewReadiness || {}),
        },
        testimony: {
          ...initialFormData.testimony,
          ...(action.data?.testimony || {}),
        },
        additionalEnrollments: action.data?.additionalEnrollments || [],
      };
    }
    case 'RESET':
      return initialFormData;
    default:
      return state;
  }
};

